import React from 'react';

import { WarningIcon } from '../../Icons/WarningIcon';
import { Text } from '../../Text/Text';

interface IProps {
  variant: 'warning' | 'error';
  text: string;
  dataTestid?: string;
}

export const FormInputWarningMessage = ({ variant, text, dataTestid }: IProps) => (
  <div
    className={`mt-2 flex items-center ${
      variant === 'warning' ? 'text-trench' : 'text-error-shade'
    }`}
    data-testid={dataTestid}
  >
    <span className="mr-1">
      <WarningIcon width={16} height={16} />
    </span>
    <Text variant="xs" className="mb-0 pt-px">
      {text}
    </Text>
  </div>
);
